import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import {
  choices,
  email,
  maxLength,
  minLength,
  minValue,
  number,
  regex,
  required,
  useRefresh,
} from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";
import TextField from "@mui/material/TextField";
import CustomAccountNumberTextField from "../../unit/forms/CustomAccountNumberTextField";
import CustomSelectVerify from "../../unit/forms/CustomSelectVerify";

const validateFirstName = [required(), minLength(2), maxLength(15)];
const validateEmail = email();
const validateAge = [number(), minValue(18)];
const validateZipCode = regex(/^\d{5}$/, "Must be a valid Zip Code");
const validateGender = choices(
  ["m", "f", "nc"],
  "Please choose one of the values"
);
const currencyAmountPattern =
  /^(?:0|[1-9]\d*|[1-9]\d{0,2}(?:,\d{3})+)(?:\.\d{2})?$/;

const isValidCurrencyAmount = (value: string) => {
  return currencyAmountPattern.test(value.trim());
};

const CustomToNotifyCollateralDialog = (props: any) => {
  const record = props.record;
  const appId = record?.id;
  const data = record?.collateral;

  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [carVin, setCarVin] = useState(data?.car_vin || "");
  const [carMake, setCarMake] = useState(data?.car_make || "");
  const [carModel, setCarModel] = useState(data?.car_model || "");
  const [carYear, setCarYear] = useState(data?.car_year || "");
  const [carMiles, setCarMiles] = useState(data?.car_mileage || "");
  const [carEstimatedValue, setCarEstimatedValue] = useState(
    data?.car_detail_estimatedvalue || ""
  );
  const [carEstimatedValueError, setCarEstimatedValueError] = useState("");
  const [carValueEstimateSource, setCarValueEstimateSource] = useState(
    data?.car_detail_valueEstimateSource || ""
  );
  const refresh = useRefresh();
  const handleSaveCollateral = async () => {
    const formJson = {
      car_vin: carVin,
      car_make: carMake,
      car_model: carModel,
      car_year: carYear,
      car_mileage: carMiles,
      car_detail_estimatedvalue: carEstimatedValue,
      car_detail_valueEstimateSource: carValueEstimateSource,
    };

    if (!carVin) {
      const vinError = "VIN is required";
      errorNotify(vinError);
      return false;
    }
    if (
      carEstimatedValue &&
      !isValidCurrencyAmount(String(carEstimatedValue || ""))
    ) {
      const amountError = "Estimated Value ($) must be a valid amount";
      setCarEstimatedValueError(amountError);
      errorNotify(amountError);
      return false;
    }
    setCarEstimatedValueError("");

    const reqUrl = `applications/actions/notify/collateral`;
    const response = await sendRequest(reqUrl, { id: appId, data: formJson });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Collateral Data saved successfully");
      refresh();
    } else {
      errorNotify(response?.message || "Data not saved!");
    }
  };

  return (
    <>
      <Grid container>
        {/* save button */}
        <Grid
          container
          sx={{
            position: "sticky",
            top: "25px",
            zIndex: 2,
            justifyContent: "flex-end",
            // backgroundColor: "#fff",
            pb: 1,
          }}
        >
          <Grid item>
            <CustomButtonSave
              type="submit"
              className="btn btn-primary"
              variant="contained"
              label="Save"
              onClick={handleSaveCollateral}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 2, pb: 2, pt: 2 }}>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="VIN" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="vin"
                name="vin"
                value={carVin}
                variant="outlined"
                onChange={(e) => {
                  setCarVin(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="Make" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="car_make"
                name="car_make"
                variant="outlined"
                fullWidth={true}
                value={carMake}
                onChange={(e) => setCarMake(e.target.value)}
                // required={true}
                // helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="Model" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="car_model"
                name="car_model"
                variant="outlined"
                fullWidth={true}
                value={carModel}
                onChange={(e) => setCarModel(e.target.value)}
                // required={true}
                // helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="Year" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="car_year"
                name="car_year"
                variant="outlined"
                fullWidth={true}
                value={carYear}
                onChange={(e) => setCarYear(e.target.value)}
                // required={true}
                // helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="Miles" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="car_miles"
                name="car_miles"
                variant="outlined"
                fullWidth={true}
                value={carMiles}
                onChange={(e) => setCarMiles(e.target.value)}
                // required={true}
                // helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="Estimated Value ($)" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="car_estimated_value"
                name="car_estimated_value"
                variant="outlined"
                fullWidth={true}
                value={carEstimatedValue}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  setCarEstimatedValue(inputValue);
                  if (
                    inputValue === "" ||
                    isValidCurrencyAmount(String(inputValue || ""))
                  ) {
                    setCarEstimatedValueError("");
                  } else {
                    setCarEstimatedValueError("Use amount format");
                  }
                }}
                onBlur={() => {
                  if (!isValidCurrencyAmount(String(carEstimatedValue || ""))) {
                    setCarEstimatedValueError("Use amount format");
                  }
                }}
                error={Boolean(carEstimatedValueError)}
                helperText={carEstimatedValueError}
                inputProps={{ inputMode: "decimal" }}
                // required={true}
                // helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={5} sx={{ pt: 1 }}>
              <HeaderLabelTitle title="Value Estimate Source" />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="car_value_estimate_source"
                name="car_value_estimate_source"
                variant="outlined"
                fullWidth={true}
                value={carValueEstimateSource}
                onChange={(e) => setCarValueEstimateSource(e.target.value)}
                // required={true}
                // helperText="no"
                className="numericText"
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CustomToNotifyCollateralDialog;
